
import { Tbl_ruoloEdit } from './tbl_ruoloEdit';
import { Tbl_ruoloList } from './tbl_ruoloList';
import { Tbl_ruoloShow } from './tbl_ruoloShow';
import { Tbl_ruoloCreate } from './tbl_ruoloCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_ruoloList,
    edit: Tbl_ruoloEdit,
    show: Tbl_ruoloShow,
    create: Tbl_ruoloCreate,
    icon: MapIcon
};
            